<div class="questionnaire-title-layout">{{questionnaireTitle}}</div>



// WEBPACK FOOTER //
// ./src/component/questionnire/child-title/component.questionnaire-title.html